export const profile = {
  name: "舒淇",
  enName: "Shu Qi",
  avatar:
    "https://readdy.ai/api/search-image?query=an%20elegant%20portrait%20of%20a%20graceful%20asian%20woman%20in%20a%20black%20dress%20against%20a%20soft%20warm%20beige%20studio%20backdrop%20editorial%20portrait%20photography%20warm%20neutral%20and%20rose%20tones%20minimal%20clean%20background%20high%20detail&width=800&height=1000&seq=profile-shuqi-portrait&orientation=portrait",
  intro:
    "舒淇，华语影坛极具影响力的女演员。自出道以来，她以独特的气质与细腻有力的表演，塑造了众多令人难忘的银幕形象，作品横跨文艺、商业、武侠等多种类型，是当代华语电影的重要代表人物之一。",
  facts: [
    { label: "出生日期", value: "1976 年 4 月 16 日" },
    { label: "出生地", value: "中国台湾" },
    { label: "职业", value: "演员 / 模特" },
    { label: "出道时间", value: "1995 年" },
  ],
  representativeWorks: [
    "色情男女",
    "最好的时光",
    "刺客聂隐娘",
    "非诚勿扰",
    "西游·降魔篇",
    "玻璃之城",
  ],
  awards: [
    "香港电影金像奖 最佳新演员",
    "香港电影金像奖 最佳女配角",
    "台湾电影金马奖 最佳女主角",
    "戛纳电影节 最佳导演（主演作品）",
  ],
  bio: [
    "舒淇出生于中国台湾，早年以模特身份进入演艺圈，随后凭借敏锐的表演天赋迅速崭露头角。",
    "上世纪九十年代末至新世纪，她与众多优秀导演合作，出演了大量风格各异的影片，演技日益成熟，逐渐成为华语电影最具辨识度的女演员之一。",
    "无论是文艺片中的细腻情感，还是商业大片中的强烈存在感，舒淇都能自如驾驭。她擅长在克制与爆发之间找到精准的平衡，赋予角色真实的生命力。",
    "多年来，舒淇始终保持对表演的敬畏与热情，不断挑战不同类型的角色，也因其独特的时尚气质成为众多品牌的宠儿。",
  ],
};